// src/modules/app-views/invoices/pages/Init/components/tableColumns/documentTypeColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders documentType as NF-e/NFC-e tag.
// Used by both invoices (InvoiceTypesTag) and goodsReceipt (plain Tag).
// Pass `renderTag` option to override default render (goodsReceipt uses plain Tag).
function documentTypeColumn(buildColumnProps, options = {}) {
  const {
    filter = true,
    filterOptions = ['nfe', 'nfce'],
    renderTag = null, // custom render: (record) => <JSX>
  } = options;

  return {
    title: translateX('type'),
    dataIndex: 'documentType',
    ...buildColumnProps('documentType', { sort: true, filter, filterOptions }),
    width: 80,
    align: 'center',
    render: (_, record) => {
      const type = record?.documentType;
      if (!type) return '—';
      if (renderTag) return renderTag(record);
      const label = type === 'nfce' ? 'NFC-e' : 'NF-e';
      const color = type === 'nfce' ? 'purple' : 'blue';
      return <Tag color={color}>{label}</Tag>;
    },
  };
}

export default documentTypeColumn;
